<script lang="ts">
    export let paddingHorizontal = true;
    export let paddingBottom = true;
</script>


<div class="max-w-7xl {paddingHorizontal ? 'px-16 sm:px-32 lg:px-48' : ''} {paddingBottom ? 'pb-16 sm:pb-32 lg:pb-48' : ''}"  >
    <slot />
</div>
